


















import {Vue, Component, Prop} from "vue-property-decorator";

@Component
export default class ItemsList extends Vue {
    @Prop({required: true}) list: any[];
    @Prop() max: number;
    @Prop({ default: "top" }) showMorePosition: "top" | "bottom"

    visibleParticipantsAmount = 4;
    showMoreActive = false;

    mounted() {
        if (this.max) {
            this.visibleParticipantsAmount = this.max;
        }
    }

    moreParticipantsClick() {
        this.showMoreActive = !this.showMoreActive;
    }

    get slicedList() {
        const take = this.showMoreActive ? this.list.length : this.visibleParticipantsAmount;
        return this.list.slice(0, take);
    }
}
